import './Profile.scss';

interface ProfileProps {
  name: string;
  onClick?: () => void;
  screenWidth: number;
};

const Profile = (props: ProfileProps) => {
  const companyName = props.name;
  const profileImgPath = '/images/avatar_placeholder.png';

  return (
    <div className='profile-block' onClick={() => {
      if (props.onClick) props.onClick();
    }}>
      <p>{ 'Hi ' + companyName }</p>
      <img className='profile-pic' src={profileImgPath} alt='profile-pic' />
    </div>
  );
};

export default Profile